import React from 'react';
import SbEditable from 'storyblok-react';
import TextCard from '~/components/Dynamic/TextCard';

export default function InlineIconTextCardsSection({ blok }) {
  return (
    <SbEditable content={blok} key={blok._uid}>
      <section className="my-20 md:my-28">
        <div className="container">
          <div className="flex justify-center text-center md:text-left">
            <div className="flex flex-col items-center">
              <TextCard blok={blok.textCard[0]} />

              {blok.items[0].textCard.map((item, i) => (
                <SbEditable content={item} key={item._uid}>
                  <div className="mt-16 md:mt-20">
                    <div key={`productionItem${i}`} className="justify-center md:-ml-20 md:flex">
                      <div className="w-32 h-20 mx-auto mb-6 md:w-1/4 md:pl-20 md:ml-0 md:mr-0 md:mb-0 md:h-auto">
                        <img className={`select-none object-contain h-full w-full`} draggable={false} src={item.icon.filename} alt={item.icon.alt} />
                      </div>
                      <div className="flex-col max-w-md md:flex md:w-9/12 md:pl-20">
                        <h4 className="mb-4 u-h4 text-30px">{item.heading}</h4>
                        <div className="max-w-md text-17px">
                          <p>{item.content}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </SbEditable>
              ))}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  );
}
